export const NAME = "detail-online-payment";

export const CREATE_PAYMENT_LINK_FORM = `${NAME}-CREATE_PAYMENT_LINK_FORM`;
